export const POLICY_PATHS = {
  ORDERS: 'kds/orders',
  DISABLEDS: 'admin/disableds',
  DELIVERIES: 'kds/deliveries',
  STORES: 'admin/stores',
  REJECTED_ORDERS: 'kds/rejected_orders'
};

export const POLICY_ACTIONS = {
  SHOW: 'show',
  UPDATE: 'update',
  INDEX: 'index',
  CANCEL: 'cancel',
  ASSIGN_USER: 'assign_user',
  ASSIGN_EXTERNAL_ID: 'assign_external_id',
  CREATE: 'create'
};
